export { formatDateShort, formatDate, parseDate };

// Добавить функцию для короткого формата даты
function formatDateShort(timestamp) {
    if (!timestamp) return "Нет данных";
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" });
  }

  // Функция для форматирования даты
const formatDate = (timestamp) => {
    return timestamp ? new Date(timestamp * 1000).toLocaleDateString("ru-RU", { year: "numeric", month: "long", day: "numeric" }) : "Нет данных";
  };

const parseDate = (strDate) => {
    const [y, m, d] = strDate.split("-"); // splits "26-02-2012" or "26/02/2012"
    const date = new Date(y, m - 1, d);
    return date.getTime() / 1000;
  };
  